import { render, staticRenderFns } from "./ModuleDataBatchSync.vue?vue&type=template&id=3273bbec"
import script from "./ModuleDataBatchSync.vue?vue&type=script&lang=js"
export * from "./ModuleDataBatchSync.vue?vue&type=script&lang=js"
import style0 from "./ModuleDataBatchSync.vue?vue&type=style&index=0&id=3273bbec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports